import React from "react";
import axios from "axios";
import localStorageService from "app/services/localStorageService";
import styles from "../../styles/app/app.scss";
import Resizer from "react-image-file-resizer";

export function validateCPF(cpf) {
  if (cpf === undefined) return true;

  var $numeros, $digitos, $soma, $i, $resultado, $digitos_iguais;
  var $cpf = cpf.replaceAll(".", "").replaceAll("_", "").replaceAll("-", "");

  if ($cpf === "") return true;

  $digitos_iguais = 1;
  if ($cpf.length < 11) return false;
  for ($i = 0; $i < $cpf.length - 1; $i++)
    if ($cpf.charAt($i) != $cpf.charAt($i + 1)) {
      $digitos_iguais = 0;
      break;
    }
  if (!$digitos_iguais) {
    $numeros = $cpf.substring(0, 9);
    $digitos = $cpf.substring(9);
    $soma = 0;
    for ($i = 10; $i > 1; $i--) $soma += $numeros.charAt(10 - $i) * $i;
    $resultado = $soma % 11 < 2 ? 0 : 11 - ($soma % 11);
    if ($resultado != $digitos.charAt(0)) return false;
    $numeros = $cpf.substring(0, 10);
    $soma = 0;
    for ($i = 11; $i > 1; $i--) $soma += $numeros.charAt(11 - $i) * $i;
    $resultado = $soma % 11 < 2 ? 0 : 11 - ($soma % 11);
    if ($resultado != $digitos.charAt(1)) return false;
    return true;
  } else return false;
}

export function validateCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj == "") return false;

  if (cnpj.length != 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
}

export const listaEstados = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

export const listaEstadosIbge = [
  { Codigo: 12, Sigla: "AC", Estado: "Acre" },
  { Codigo: 27, Sigla: "AL", Estado: "Alagoas" },
  { Codigo: 13, Sigla: "AM", Estado: "Amazonas" },
  { Codigo: 16, Sigla: "AP", Estado: "Amapá" },
  { Codigo: 29, Sigla: "BA", Estado: "Bahia" },
  { Codigo: 23, Sigla: "CE", Estado: "Ceará" },
  { Codigo: 53, Sigla: "DF", Estado: "Distrito Federal" },
  { Codigo: 32, Sigla: "ES", Estado: "Espírito Santo" },
  { Codigo: 52, Sigla: "GO", Estado: "Goiás" },
  { Codigo: 21, Sigla: "MA", Estado: "Maranhão" },
  { Codigo: 31, Sigla: "MG", Estado: "Minas Gerais" },
  { Codigo: 50, Sigla: "MS", Estado: "Mato Grosso do Sul" },
  { Codigo: 51, Sigla: "MT", Estado: "Mato Grosso" },
  { Codigo: 15, Sigla: "PA", Estado: "Pará" },
  { Codigo: 25, Sigla: "PB", Estado: "Paraíba" },
  { Codigo: 26, Sigla: "PE", Estado: "Pernambuco" },
  { Codigo: 22, Sigla: "PI", Estado: "Piauí" },
  { Codigo: 41, Sigla: "PR", Estado: "Paraná" },
  { Codigo: 33, Sigla: "RJ", Estado: "Rio de Janeiro" },
  { Codigo: 24, Sigla: "RN", Estado: "Rio Grande do Norte" },
  { Codigo: 11, Sigla: "RO", Estado: "Rondônia" },
  { Codigo: 14, Sigla: "RR", Estado: "Roraima" },
  { Codigo: 43, Sigla: "RS", Estado: "Rio Grande do Sul" },
  { Codigo: 42, Sigla: "SC", Estado: "Santa Catarina" },
  { Codigo: 28, Sigla: "SE", Estado: "Sergipe" },
  { Codigo: 35, Sigla: "SP", Estado: "São Paulo" },
  { Codigo: 17, Sigla: "TO", Estado: "Tocantins" },
];

export const diasSemana = [
  { idDiaSemana: 0, dsDiaSemana: "Domingo", sgDiaSemana: "Dom" },
  { idDiaSemana: 1, dsDiaSemana: "Segunda-Feira", sgDiaSemana: "Seg" },
  { idDiaSemana: 2, dsDiaSemana: "Terça-Feira", sgDiaSemana: "Ter" },
  { idDiaSemana: 3, dsDiaSemana: "Quarta-Feira", sgDiaSemana: "Qua" },
  { idDiaSemana: 4, dsDiaSemana: "Quinta-Feira", sgDiaSemana: "Qui" },
  { idDiaSemana: 5, dsDiaSemana: "Sexta-Feira", sgDiaSemana: "Sex" },
  { idDiaSemana: 6, dsDiaSemana: "Sábado", sgDiaSemana: "Sab" },
];

export const listaMeses = [
  { nrMes: 1, sgMes: "Jan", nmMes: "Janeiro" },
  { nrMes: 2, sgMes: "Fev", nmMes: "Fevereiro" },
  { nrMes: 3, sgMes: "Mar", nmMes: "Março" },
  { nrMes: 4, sgMes: "Abr", nmMes: "Abril" },
  { nrMes: 5, sgMes: "Mai", nmMes: "Maio" },
  { nrMes: 6, sgMes: "Jun", nmMes: "Junho" },
  { nrMes: 7, sgMes: "Jul", nmMes: "Julho" },
  { nrMes: 8, sgMes: "Ago", nmMes: "Agosto" },
  { nrMes: 9, sgMes: "Set", nmMes: "Setembro" },
  { nrMes: 10, sgMes: "Out", nmMes: "Outubro" },
  { nrMes: 11, sgMes: "Nov", nmMes: "Novembro" },
  { nrMes: 12, sgMes: "Dez", nmMes: "Dezembro" },
];

export const formatarHora = (time) => {
  if (time === undefined) return "";

  if (Object.getPrototypeOf(time) === Object.getPrototypeOf("")) {
    return time;
  }

  const hh = time.hours.toString().padStart(2, 0);
  const mm = time.minutes.toString().padStart(2, 0);

  return hh + ":" + mm;
};

export const CamposExperiencia = [
  { IdCampoExperiencia: 1, DsCampoExperiencia: "O EU, O OUTRO E O NÓS" },
  { IdCampoExperiencia: 2, DsCampoExperiencia: "CORPO, GESTOS E MOVIMENTOS" },
  { IdCampoExperiencia: 3, DsCampoExperiencia: "TRAÇOS, SONS, CORES E FORMAS" },
  {
    IdCampoExperiencia: 4,
    DsCampoExperiencia: "ESCUTA, FALA, PENSAMENTO E IMAGINAÇÃO",
  },
  {
    IdCampoExperiencia: 5,
    DsCampoExperiencia:
      "ESPAÇOS, TEMPOS, QUANTIDADES, RELAÇÕES E TRANSFORMAÇÕES",
  },
];

export const GetBase64 = (file) => {
  return new Promise((resolve) => {
    let $fileInfo;
    const $reader = new FileReader();

    $reader.readAsDataURL(file);
    $reader.onload = () => {
      const $baseURL = $reader.result;
      resolve($baseURL);
    };
  });
};

export const DataPorExtenso = (data) => {
  const day = [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
  ][data.getDay()];
  const date = data.getDate();
  const month = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ][data.getMonth()];
  const year = data.getFullYear();

  return `${day}, ${date} de ${month} de ${year}`;
};

export const ResizeFile = (file) => {
  return new Promise((resolve) => {
    try {
      Resizer.imageFileResizer(
        file,
        500,
        500,
        "JPEG",
        100,
        0,
        (uri) => {
          urltoFile(uri, "newfile.jpg", "image/jpeg").then((newFile) => {
            resolve(newFile);
          });
        },
        "base64"
      );
    } catch (error) {
      resolve(undefined);
    }
  });
};

function urltoFile(url, filename, mimeType) {
  return fetch(url)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      return new File([buf], filename, { type: mimeType });
    });
}

export const InstanceAxios = () => {
  const auth = localStorageService.getItem("auth_user");
  if (auth !== undefined && auth !== null) {
    if (axios.defaults.headers.common["Authorization"] === undefined) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${auth.token}`;
    }
  }
};

export const BuscaEnderecoCep = ({ cep = "" }) =>
  new Promise((resolve) => {
    axios
      .get(`https://viacep.com.br/ws/${cep}/json/`, { headers: null })
      .then((retorno) => resolve(retorno))
      .catch(() => resolve({ status: 400, data: null }));
  });

export const BuscaMunicipioPorUF = ({ uf = "" }) =>
  new Promise((resolve) => {
    if (uf !== "") {
      axios
        .get(`/api/municipio/uf/${uf}`)
        .then((retorno) => resolve(retorno))
        .catch(() => resolve({ status: 400, data: [] }));
    } else {
      resolve({ status: 204, data: [] });
    }
  });
